import { useGTMReadCards } from '@/fo/api/gtm';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';
import { Review, Question, ReviewTab } from '@/fo/ui/review/catalog/base';
import { ReviewImage } from '@/fo/ui/review/gallery/base';

import { QuestionCard } from '../QuestionCard/QuestionCard';
import { ReviewCard } from '../ReviewCard/ReviewCard';

import { styles } from './ReviewsCarousel.styles';

export interface ReviewsCarouselProps {
  items: Review[] | Question[];
  type: ReviewTab;
  onReviewClick?: (review: Review) => void;
  onQuestionClick?: (question: Question) => void;
  onImageClick?: (imageId: string, images: ReviewImage[]) => void;
}

/**
 * TODO:
 * - Добавить lazy loading компонента карусели
 */
export function ReviewsCarousel({
  items,
  type,
  onReviewClick,
  onQuestionClick,
  onImageClick
}: ReviewsCarouselProps) {
  const slots = styles();
  const isReviewsType = type === ReviewTab.Reviews;
  const gtmRef = useGTMReadCards(
    isReviewsType ? 'read_review' : 'read_question',
    'preview',
    items.length
  );

  const isDesktop = useMediaQuery('xl');

  const itemsNode = isReviewsType
    ? (items as Review[]).map((review) => (
        <div
          key={review.id}
          className={slots.card()}
          data-gtm-read-target=""
        >
          <ReviewCard
            review={review}
            onClick={() => onReviewClick?.(review)}
            onImageClick={onImageClick}
          />
        </div>
      ))
    : (items as Question[]).map((question) => (
        <div
          key={question.id}
          className={slots.card()}
          data-gtm-read-target=""
        >
          <QuestionCard
            question={question}
            onClick={() => onQuestionClick?.(question)}
          />
        </div>
      ));

  if (isDesktop) {
    return (
      <div
        ref={gtmRef}
        className={slots.base()}
      >
        {itemsNode}
      </div>
    );
  }

  return (
    <div ref={gtmRef}>
      <UiKitCarouselBase
        showArrows={true}
        loop={false}
        className={slots.carousel()}
        viewportClassName={slots.viewport()}
      >
        {itemsNode}
      </UiKitCarouselBase>
    </div>
  );
}
